/**
 * Merge a second `onNewMessage` delivery into an existing row (e.g. a stub
 * from `onMessageUpdate` with no `widgetType`/`widgetData`). Prefer non-null
 * incoming values; never replace an existing non-null field with a null or
 * absent one from a partial payload.
 *
 * @param {object} existing
 * @param {object} normalized
 * @param {object} raw
 */
export function mergeOnNewMessageIntoExisting(existing, normalized, raw) {
  const merged = { ...existing, ...normalized };

  const rawWidgetType = raw?.widgetType;
  const missingWidgetType = rawWidgetType == null
    || (typeof rawWidgetType === 'string' && rawWidgetType.trim() === '');

  if (missingWidgetType) {
    merged.widgetType = existing.widgetType != null ? existing.widgetType : null;
  } else {
    merged.widgetType = rawWidgetType;
  }

  if (raw?.widgetData == null) {
    merged.widgetData = existing.widgetData != null ? existing.widgetData : null;
  } else {
    merged.widgetData = raw.widgetData;
  }

  if (raw?.widgetActionUserId == null) {
    merged.widgetActionUserId = existing.widgetActionUserId != null
      ? existing.widgetActionUserId
      : null;
  } else {
    merged.widgetActionUserId = raw.widgetActionUserId;
  }

  if (raw?.content == null) {
    merged.content = existing.content;
  }

  if (raw?.isComplete == null) {
    merged.isComplete = existing.isComplete;
  }

  if (raw?.reactionCounts == null) {
    merged.reactionCounts = existing.reactionCounts != null ? existing.reactionCounts : null;
  }

  if (raw?.threadParentId == null) {
    merged.threadParentId = existing.threadParentId != null ? existing.threadParentId : null;
  } else {
    merged.threadParentId = raw.threadParentId;
  }

  if (raw?.threadReplyCount == null) {
    merged.threadReplyCount = Number.isFinite(existing.threadReplyCount) ? existing.threadReplyCount : 0;
  }

  if (raw?.createdAt == null && raw?.timestamp == null) {
    merged.createdAt = existing.createdAt;
    merged.timestamp = existing.timestamp;
  }

  if (raw?.senderId == null && raw?.senderUsername == null) {
    merged.senderId = existing.senderId;
  }

  if (raw?.senderDisplayName == null) {
    merged.senderDisplayName = existing.senderDisplayName;
  }

  return merged;
}
